import React from "react";
import { Card, Table } from "react-bootstrap";
import PropTypes from "prop-types";
const TableTopData = ({ data, title }) => {
  return (
    <>
      <Card>
        <Card.Header className="card-header">
          <div className="ms-auto">
            <b> {title} </b>
            {/* {data && (
              <BtnExportToExcell
                dataReport={data}
                fileName={"Report" + title}
                label="Exp"
              ></BtnExportToExcell>
            )} */}
          </div>
        </Card.Header>
        <Card.Body>
          <Table responsive>
            <tbody>
              {data &&
                data.map((item) => {
                  return (
                    <tr key={item.name}>
                      <td>{item.name}</td>
                      <td>{item.value}</td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </>
  );
};
TableTopData.propTypes = {
  data: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
};
export default TableTopData;
